module.exports = __webpack_public_path__ + "static/img/defaultAva.73af6290.svg";